<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col cols="12" md="4" lg="3">
                <search-bar-instant v-model="query.searchString" />
            </v-col>
            <v-col cols="12" md="4" lg="3">
                <sort-bar v-model="query.sort" v-bind:items="sortItems" />
            </v-col>
        </v-row>
        <v-row class="mx-1 my-4" justify="center">
            <v-col cols="12" sm="8" md="6" class="d-flex justify-end">
                <v-btn color="primary" v-on:click="addLocation">
                    <v-icon class="mr-2">mdi-plus</v-icon>
                    Add
                </v-btn>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" sm="8" md="6">
                <v-card
                    class="mb-4"
                    v-for="item in listItems"
                    v-bind:key="item.id"
                >
                    <v-card-title>{{ item.name }}</v-card-title>
                    <v-card-subtitle>ID: {{ item.id }}</v-card-subtitle>
                    <v-divider />
                    <v-card-actions>
                        <v-btn
                            tile
                            class="mx-2"
                            v-on:click="openServicecharges(item.id)"
                            v-bind:loading="$store.state.app.loading"
                            >Service charges</v-btn
                        >
                        <v-spacer />
                        <v-icon class="mr-2" v-on:click="editLocation(item)"
                            >mdi-pencil</v-icon
                        >
                        <v-icon class="mr-2" v-on:click="deleteLocation(item)"
                            >mdi-delete</v-icon
                        >
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog width="290px" v-model="shouldShowForm">
            <v-card tile>
                <v-card-subtitle class="py-4">{{ formHeader }}</v-card-subtitle>
                <v-divider />
                <v-form class="ma-4" v-on:submit.prevent>
                    <v-text-field
                        filled
                        autofocus
                        hide-details
                        label="Name"
                        prepend-inner-icon="mdi-map-marker"
                        v-model="currentLocation.name"
                    ></v-text-field>
                    <small v-if="currentLocationNameExists"
                        ><v-icon small>mdi-exclamation</v-icon>(already
                        exists)</small
                    >
                </v-form>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <v-btn class="mr-2" v-on:click="shouldShowForm = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        class="mr-2"
                        v-on:click="saveLocation(currentLocation)"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import arrayUtil from '@/utils/arrayUtil';
import locationApi from '@/api/locationApi';
import snackbar from '@/utils/snackbar';
import { mapMutations } from 'vuex';

export default {
    components: {
        'search-bar-instant': () => import('@/components/SearchBarInstant.vue'),
        'sort-bar': () => import('@/components/SortBar.vue')
    },
    data() {
        return {
            query: {
                searchString: '',
                sort: null
            },
            sortItems: [
                { text: 'A-Z', value: 'asc' },
                { text: 'Z-A', value: 'desc' }
            ],
            currentLocation: {
                id: null,
                name: null
            },
            shouldShowForm: false,
            formHeader: ''
        };
    },
    computed: {
        listItems() {
            let finalList = this.$store.state.app.staticData.locations;

            finalList = finalList.filter(function(location) {
                // Search string
                const search =
                    this.query.searchString &&
                    this.query.searchString.trim().toLowerCase();

                if (search) {
                    return location.name.toLowerCase().includes(search);
                }

                return true;
            }, this);

            finalList.sort(arrayUtil.comparebyNameProperty);
            if (this.query.sort == 'desc') finalList.reverse();

            return finalList;
        },
        currentLocationNameExists() {
            if (null == this.currentLocation.name) {
                return false;
            }
            return this.$store.state.app.staticData.locations.some(l => {
                return (
                    this.currentLocation.name.toLowerCase() ==
                    l.name.toLowerCase()
                );
            });
        }
    },
    methods: {
        ...mapMutations({
            updateOrCreateLocation: 'app/UPDATE_OR_CREATE_LOCATION',
            removeLocationById: 'app/REMOVE_LOCATION_BY_ID'
        }),
        addLocation() {
            this.formHeader = 'Create new Location';
            this.currentLocation = {
                id: null,
                name: null
            };
            this.shouldShowForm = true;
        },
        editLocation(location) {
            this.formHeader = `Editing Location #${location.id}`;
            this.currentLocation = { ...location };
            this.shouldShowForm = true;
        },
        async deleteLocation(location) {
            const confirmed = confirm('Confirm deletion');
            if (!confirmed) return;
            await locationApi.deleteLocation(location.id);
            this.removeLocationById(location.id);
            snackbar.show('Deleted successfully', 'success');
        },
        async saveLocation(location) {
            this.shouldShowForm = false;
            let response = null;
            // Existing id indicates edit, else create new
            if (location.id != null) {
                // was editing
                response = await locationApi.updateLocation(
                    location.id,
                    location
                );
            } else {
                // create new
                response = await locationApi.createLocation(location);
            }

            this.updateOrCreateLocation(response.data.location);
        },
        openServicecharges(locationId) {
            this.$router.push({
                name: 'op-location-servicecharges',
                params: { location_id: locationId }
            });
        }
    }
};
</script>
